module.exports = __webpack_public_path__ + "static/media/grammar-2.ece22fab.svg";